import { Injectable } from "@angular/core";
import { catchError, map } from "rxjs/operators";
import { environment } from "./../../../../../environments/environment";
import * as HSET from "./settings";
import { GenericHttpService } from "./../../../services/generic-http.service";
import { Observable } from "rxjs";
import { GenericUtils } from './../../../utilities/generic-utils';

const genericUtils = new GenericUtils();
@Injectable({
  providedIn: 'root'
})
export class DataService {
  baseUrl = environment.gateWayHost;
  editItem: any;
  constructor(public generic: GenericHttpService, public utils: GenericUtils) { }

  getData(url, config, params): Observable<any> {
    const option = {
      method: "GET",
      url: `${this.baseUrl}${url}`,
      query: params
    };

    const functionToExecute = this.getFunctionToExecute(config.id);
    return this.generic.httpRequest(option).pipe(
      catchError(this.generic.handleError),
      map(functionToExecute)
    );
  }

  getFunctionToExecute(id) {
    if (id === 30) {
      return this.processOrderStatusHighlight;
    }
  }

  processOrderStatusHighlight(data) {
    if (!data.data || !Object.keys(data.data).length) return null
    let dataPoints, formatterString, total = 0;

    Object.keys(data.data).map(pointName => {
      let temp = isNaN(data.data[pointName]) ? 0 : data.data[pointName];
      if (['delivered', 'in_transit', 'invoiced', 'to_be_invoiced'].indexOf(pointName) < 0) {
        temp = 0;
      }
      total += temp;
    });
    //total = data.data.total;

    dataPoints = [total,
      isNaN(data.data.delivered) ? 0 : -data.data.delivered,
      isNaN(data.data.in_transit) ? 0 : -data.data.in_transit,
      isNaN(data.data.invoiced) ? 0 : -data.data.invoiced,
      isNaN(data.data.to_be_invoiced) ? 0 : -data.data.to_be_invoiced
    ]

    formatterString = `Total Units Ordered: ${genericUtils.amountIndianUnit(total)} <br/>
      Delivered: ${genericUtils.amountIndianUnit(data.data.delivered)}<br>
      In Transit: ${genericUtils.amountIndianUnit(data.data.in_transit)}<br>
      BBND: ${genericUtils.amountIndianUnit(data.data.invoiced)}<br>
      To Be invoiced: ${genericUtils.amountIndianUnit(data.data.to_be_invoiced)}`


    return { dataPoints, formatterString };


  }

  createChart(chartData, chartOptions) {
    const chart = this.utils.deepCopyFunction(HSET.chartData);
    chart.series[0].data = [];


    for (let i = 0; i < chartData.dataPoints.length; i++) {
      const seriesData = {
        y: chartData.dataPoints[i],
        name: chartOptions[0].series.name[i],
        color: chartOptions[0].series.color[i],
        myData: chartData.formatterString
      }
      chart.series[0].data[i] = seriesData;

    }

    // chart.series[0].data[0].y = total;
    // chart.series[0].data[0].myData = chartData;
    // chart.series[0].data[1].y = isNaN(chartData.delivered) ? 0 : -chartData.delivered;
    // chart.series[0].data[1].myData = chartData;
    // chart.series[0].data[2].y = isNaN(chartData.in_transit) ? 0 : -chartData.in_transit;
    // chart.series[0].data[2].myData = chartData;
    // chart.series[0].data[3].y = isNaN(chartData.invoiced) ? 0 : -chartData.invoiced;
    // chart.series[0].data[3].myData = chartData;
    // chart.series[0].data[4].y = isNaN(chartData.to_be_invoiced) ? 0 : -chartData.to_be_invoiced;
    // chart.series[0].data[4].myData = chartData;
    return chart;
  }
}
